<template>
  <div class="change-indicator">
    <q-icon
      :name="icon"
      :class="colorClass"
      size="19px"
      style="margin-bottom: -1px"
    />
    <span :class="colorClass" class="text-weight-bold">
      ${{ formatNumber(Math.abs(priceChange)) }}
    </span>
  </div>
</template>

<script>
export default {
  name: "PriceChangeIndicator",
  props: {
    priceChange: {
      type: Number,
      required: true
    }
  },
  computed: {
    icon() {
      return this.priceChange < 0
        ? "sym_r_arrow_downward"
        : "sym_r_arrow_upward";
    },
    colorClass() {
      return this.priceChange < 0 ? "text-positive" : "text-negative";
    }
  }
};
</script>

<style lang="scss" scoped>
.change-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
